// extracted by mini-css-extract-plugin
module.exports = {"spinner":"spinner_spinner__3YFp5","rotate":"spinner_rotate__OU6lq"};